import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginBaseComponent } from './features/login/login-base/login-base.component';
import { BaseComponent } from './core/base/base.component';
import { AboutStokkupComponent } from './features/about/about-stokkup/about-stokkup.component';
import { PrivacyPolicyComponent } from './features/about/privacy-policy/privacy-policy.component';
import { SupportComponent } from './features/about/support/support.component';
import { TermsOfServiceComponent } from './features/about/terms-of-service/terms-of-service.component';
import { BaseNavResolver } from './core/resolver/base-nav.resolver';
import { SelectedDecoratorGuard } from '@core/guards/selected-decorator.guard';
import { AuthGuard } from '@core/guards/auth.guard';
import { SignupComponent } from '@features/signup/signup.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/catalog',
    pathMatch: 'full'
  },
  { 
    path: 'login',
    component: LoginBaseComponent,
    resolve: { baseResolver: BaseNavResolver },
    loadChildren: () => import('./features/login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'signup',
    component: SignupComponent
  },
  {
    // Public, login-free order view via a secure live link (Story 7.1). No auth
    // guard — the token is validated server-side by the token-gated endpoint;
    // PublicOrderModule renders the read-only order. BaseComponent renders its
    // guest navbar (logo + Login) for anonymous visitors.
    path: 'order',
    component: BaseComponent,
    resolve: { baseResolver: BaseNavResolver },
    loadChildren: () => import('./features/public-order/public-order.module').then(m => m.PublicOrderModule),
  },
  { 
    path: 'orders',
    component: BaseComponent,
    resolve: { baseResolver: BaseNavResolver },
    loadChildren: () => import('./features/orders/orders.module').then(m => m.OrdersModule),
  },
  {
    path: 'shipping',
    component: BaseComponent,
    resolve: { baseResolver: BaseNavResolver },
    loadChildren: () => import('./features/shipping/shipping.module').then(m => m.ShippingModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'floor-stock',
    component: BaseComponent,
    resolve: { baseResolver: BaseNavResolver },
    loadChildren: () => import('./features/floor-stock/floor-stock.module').then(m => m.FloorStockModule),
    canActivate: [AuthGuard, SelectedDecoratorGuard]
  },
  { 
    path: 'catalog',
    component: BaseComponent,
    resolve: { baseResolver: BaseNavResolver },
    loadChildren: () => import('./features/catalog/catalog.module').then(m => m.CatalogModule),
    canActivate: [SelectedDecoratorGuard]
  },
  {
    // Story 11.3: the standalone Dashboard is retired — its insights now live on
    // the Orders home. Redirect old /dashboard links to /orders.
    path: 'dashboard',
    redirectTo: 'orders',
    pathMatch: 'full'
  },
  { 
    path: 'cart',
    component: BaseComponent,
    resolve: { baseResolver: BaseNavResolver },
    loadChildren: () => import('./features/cart/cart.module').then(m => m.CartModule),
    canActivate: [AuthGuard, SelectedDecoratorGuard]
  },
  {
    path: 'about',
    component: BaseComponent,
    resolve: { baseResolver: BaseNavResolver },
    children: [
      { path: '', component: AboutStokkupComponent },
      { path: 'privacy-policy', component: PrivacyPolicyComponent },
      { path: 'support', component: SupportComponent },
      { path: 'terms-of-service', component: TermsOfServiceComponent },
    ]
  },
  {
    path: '**',
    redirectTo: 'catalog'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
